import React, { useState } from 'react';
import PDDashboard from './PDDashboard';
import PeerLearningHub from './PeerLearningHub';
import SelfLearningPanel from './SelfLearningPanel';
import TeamOversightPanel from './TeamOversightPanel';
import CompanyTrainingHub from './CompanyTrainingHub';
import HROversightPanel from './HROversightPanel';

export default function ProfessionalDevelopment({ userProfile, appId }) {
    const [activeTab, setActiveTab] = useState('dashboard');
    
    // ✅ FIX: Define the variable here
const isHRAdmin = userProfile.role === 'HR' || 
                      userProfile.role === 'Admin' || 
                      userProfile.department === 'HR';
    return (
        <div className="space-y-6">
            {/* Header */}
            <div className="flex flex-col md:flex-row justify-between items-center">
                <div>
                    <h2 className="text-2xl font-bold text-[#213368]">Professional Development</h2>
                    <p className="text-sm text-gray-500">Track your growth across the 4 Pillars of Excellence.</p>
                </div>
            </div>

            {/* Navigation */}
            <div className="flex space-x-1 border-b border-gray-200 overflow-x-auto">
                <TabButton id="dashboard" label="My Dashboard" activeTab={activeTab} setActiveTab={setActiveTab} />
                <TabButton id="self_learning" label="Self-Learning & Skills" activeTab={activeTab} setActiveTab={setActiveTab} />
                <TabButton id="training_calendar" label="Organised Training" activeTab={activeTab} setActiveTab={setActiveTab} />
                <TabButton id="peer" label="Peer Learning" activeTab={activeTab} setActiveTab={setActiveTab} />
                <TabButton id="team" label="Team Oversight" activeTab={activeTab} setActiveTab={setActiveTab} />
                
                {/* ✅ FIX: Now this variable exists and won't error */}
                {isHRAdmin && (
                    <TabButton id="company_report" label="Company Reports" activeTab={activeTab} setActiveTab={setActiveTab} />
                )}
            </div>

            {/* Content Area */}
            <div className="bg-white p-6 rounded-b-lg rounded-tr-lg shadow-sm border border-gray-200 min-h-[500px]">
                {activeTab === 'dashboard' && <PDDashboard userProfile={userProfile} appId={appId} />}
                {activeTab === 'self_learning' && <SelfLearningPanel userProfile={userProfile} appId={appId} />}
                {activeTab === 'training_calendar' && <CompanyTrainingHub userProfile={userProfile} appId={appId} />}
                {activeTab === 'peer' && <PeerLearningHub userProfile={userProfile} appId={appId} />}
                {activeTab === 'team' && <TeamOversightPanel userProfile={userProfile} appId={appId} />}
                
                {/* ✅ FIX: Render logic matches navigation logic */}
                {activeTab === 'company_report' && isHRAdmin && <HROversightPanel appId={appId} />}
            </div>
        </div>
    );
}

function TabButton({ id, label, activeTab, setActiveTab }) {
    const isActive = activeTab === id;
    return (
        <button
            onClick={() => setActiveTab(id)}
            className={`whitespace-nowrap px-6 py-3 text-sm font-medium transition-colors border-b-2 rounded-t-lg ${
                isActive 
                    ? 'border-[#20BEC6] text-[#20BEC6] bg-blue-50' 
                    : 'border-transparent text-gray-500 hover:text-[#213368] hover:bg-gray-50'
            }`}
        >
            {label}
        </button>
    );
}